import * as actions from './actions'
import * as types from './mutation-types'

const state = {
  vfusList:[],
  vfusError: '',
  vfusLoading: false,
  pgusList:[],
  pgusError: '',
  pgusLoading: false,
  zoneDeviceItem: {},
  irrigationZoneItem: {},
  co2ZoneItem: {},
  growZoneItem: {},
  workZoneItem: {},
  platformGroupDevicesList:[],
  platformGroupDevicesError: '',
  platformGroupDevicesLoading: false,
  temperatureChartData:[],
  temperatureChartDataError: '',
  temperatureChartDataLoading: false,
  humidityChartData:[],
  humidityChartDataError: '',
  humidityChartDataLoading: false,
  co2ChartDataError: '',
  co2ChartData:[],
  co2ChartDataLoading: false,
  executeBatchActionList:[],
  executeBatchActionError: '',
  executeBatchActionLoading: false,
}

const getters = {

  executeBatchActionLoading: state => state.executeBatchActionLoading,
  executeBatchActionError: state => state.executeBatchActionError,
  executeBatchActionList: state => state.executeBatchActionList,

  vfusLoading: state => state.vfusLoading,
  vfusError: state => state.vfusError,
  vfusList: state => state.vfusList,
  pgusLoading: state => state.pgusLoading,
  pgusError: state => state.pgusError,
  pgusList: state => state.pgusList,
  platformGroupDevicesLoading: state => state.platformGroupDevicesLoading,
  platformGroupDevicesError: state => state.platformGroupDevicesError,
  platformGroupDevicesList: state => state.platformGroupDevicesList,
  temperatureChartDataLoading: state => state.temperatureChartDataLoading,
  temperatureChartDataError: state => state.temperatureChartDataError,
  temperatureChartData: state => state.temperatureChartData,
  humidityChartDataLoading: state => state.humidityChartDataLoading,
  humidityChartDataError: state => state.humidityChartDataError,
  humidityChartData: state => state.humidityChartData,
  co2ChartDataLoading: state => state.co2ChartDataLoading,
  co2ChartDataError: state => state.co2ChartDataError,
  co2ChartData: state => state.co2ChartData,
  zoneDeviceItemLoading: state => state.zoneDeviceItemLoading,
  zoneDeviceItemError: state => state.zoneDeviceItemError,
  zoneDeviceItemVal: state => state.zoneDeviceItem,
  irrigationZoneItemLoading: state => state.irrigationZoneItemLoading,
  irrigationZoneItemError: state => state.irrigationZoneItemError,
  irrigationZoneItemVal: state => state.irrigationZoneItem,
  co2ZoneItemLoading: state => state.co2ZoneItemLoading,
  co2ZoneItemError: state => state.co2ZoneItemError,
  co2ZoneItemVal: state => state.co2ZoneItem,
  growZoneItemLoading: state => state.growZoneItemLoading,
  growZoneItemError: state => state.growZoneItemError,
  growZoneItemVal: state => state.growZoneItem,
  workZoneItemLoading: state => state.workZoneItemLoading,
  workZoneItemError: state => state.workZoneItemError,
  workZoneItemVal: state => state.workZoneItem
}

const mutations = {
   [types.GET_EXECUTE_VFU_BATCH_REQUEST] (state){
    state.vfusLoading = true;
    state.vfusList = [];
    state.vfusError = {};
  },
  [types.GET_EXECUTE_VFU_BATCH_SUCCESS] (state, vfus){
    state.vfusLoading = false;
    state.vfusList = vfus;
    state.vfusError = {};
  },
  [types.GET_EXECUTE_VFU_BATCH_FAILURE] (state, error){
    state.vfusLoading = false;
    state.vfusList = [];
    state.vfusError = error;
  },


  [types.GET_VFUS_REQUEST] (state){
    state.vfusLoading = true;
    state.vfusList = [];
    state.vfusError = {};
  },
  [types.GET_VFUS_SUCCESS] (state, vfus){
    state.vfusLoading = false;
    state.vfusList = vfus;
    state.vfusError = {};
  },
  [types.GET_VFUS_FAILURE] (state, error){
    state.vfusLoading = false;
    state.vfusList = [];
    state.vfusError = error;
  },
  [types.GET_PGUS_REQUEST] (state){
    state.pgusLoading = true;
    state.pgusList = [];
    state.pgusError = {};
  },
  [types.GET_PGUS_SUCCESS] (state, pgus){
    state.pgusLoading = false;
    state.pgusList = pgus;
    state.pgusError = {};
  },
  [types.GET_PGUS_FAILURE] (state, error){
    state.pgusLoading = false;
    state.pgusList = [];
    state.pgusError = error;
  },
  [types.GET_PG_DEVICES_REQUEST] (state){
    state.platformGroupDevicesLoading = true;
    state.platformGroupDevicesList = [];
    state.platformGroupDevicesError = {};
  },
  [types.GET_PG_DEVICES_SUCCESS] (state, platformGroupDevices){
    state.platformGroupDevicesLoading = false;
    state.platformGroupDevicesList = platformGroupDevices;
    state.platformGroupDevicesError = {};
  },
  [types.GET_PG_DEVICES_FAILURE] (state, error){
    state.platformGroupDevicesLoading = false;
    state.platformGroupDevicesList = [];
    state.platformGroupDevicesError = error;
  },
  [types.GET_TEMPERATURE_DATA_REQUEST] (state){
    state.temperatureChartDataLoading = true;
    state.temperatureChartData = [];
    state.temperatureChartDataError = {};
  },
  [types.GET_TEMPERATURE_DATA_SUCCESS] (state, temperatureChartData){
    state.temperatureChartDataLoading = false;
    state.temperatureChartData = temperatureChartData;
    state.temperatureChartDataError = {};
  },
  [types.GET_TEMPERATURE_DATA_FAILURE] (state, error){
    state.temperatureChartDataLoading = false;
    state.temperatureChartData = [];
    state.temperatureChartDataError = error;
  },
  [types.GET_HUMIDITY_DATA_REQUEST] (state){
    state.humidityChartDataLoading = true;
    state.humidityChartData = [];
    state.humidityChartDataError = {};
  },
  [types.GET_HUMIDITY_DATA_SUCCESS] (state, humidityChartData){
    state.humidityChartDataLoading = false;
    state.humidityChartData = humidityChartData;
    state.humidityChartDataError = {};
  },
  [types.GET_HUMIDITY_DATA_FAILURE] (state, error){
    state.humidityChartDataLoading = false;
    state.humidityChartData = [];
    state.humidityChartDataError = error;
  },
  [types.GET_CO_TWO_DATA_REQUEST] (state){
    state.co2ChartDataLoading = true;
    state.co2ChartData = [];
    state.co2ChartDataError = {};
  },
  [types.GET_CO_TWO_DATA_SUCCESS] (state, co2ChartData){
    state.co2ChartDataLoading = false;
    state.co2ChartData = co2ChartData;
    state.co2ChartDataError = {};
  },
  [types.GET_CO_TWO_DATA_FAILURE] (state, error){
    state.co2ChartDataLoading = false;
    state.co2ChartData = [];
    state.co2ChartDataError = error;
  },
  [types.GET_ZONE_DEVICE_REQUEST] (state){
    state.zoneDeviceItemLoading = true;
    state.zoneDeviceItem = {};
    state.zoneDeviceItemError = {};
  },
  [types.GET_ZONE_DEVICE_SUCCESS] (state, zoneDevice){
    state.zoneDeviceItemLoading = false;
    state.zoneDeviceItem = zoneDevice;
    state.zoneDeviceItemError = {};
  },
  [types.GET_ZONE_DEVICE_FAILURE] (state, error){
    state.zoneDeviceItemLoading = false;
    state.zoneDeviceItem = {};
    state.zoneDeviceItemError = error;
  },
  [types.GET_IRRIGATION_ZONE_REQUEST] (state){
    state.irrigationZoneItemLoading = true;
    state.irrigationZoneItem = {};
    state.irrigationZoneItemError = {};
  },
  [types.GET_IRRIGATION_ZONE_SUCCESS] (state, zone){
    state.irrigationZoneItemLoading = false;
    state.irrigationZoneItem = zone;
    state.irrigationZoneItemError = {};
  },
  [types.GET_IRRIGATION_ZONE_FAILURE] (state, error){
    state.irrigationZoneItemLoading = false;
    state.irrigationZoneItem = {};
    state.irrigationZoneItemError = error;
  },
  [types.GET_CO2_ZONE_REQUEST] (state){
    state.co2ZoneItemLoading = true;
    state.co2ZoneItem = {};
    state.co2ZoneItemError = {};
  },
  [types.GET_CO2_ZONE_SUCCESS] (state, zone){
    state.co2ZoneItemLoading = false;
    state.co2ZoneItem = zone;
    state.co2ZoneItemError = {};
  },
  [types.GET_CO2_ZONE_FAILURE] (state, error){
    state.co2ZoneItemLoading = false;
    state.co2ZoneItem = {};
    state.co2ZoneItemError = error;
  },
  [types.GET_GROW_ZONE_REQUEST] (state){
    state.growZoneItemLoading = true;
    state.growZoneItem = {};
    state.growZoneItemError = {};
  },
  [types.GET_GROW_ZONE_SUCCESS] (state, zone){
    state.growZoneItemLoading = false;
    state.growZoneItem = zone;
    state.growZoneItemError = {};
  },
  [types.GET_GROW_ZONE_FAILURE] (state, error){
    state.growZoneItemLoading = false;
    state.growZoneItem = {};
    state.growZoneItemError = error;
  },
  [types.GET_WORK_ZONE_REQUEST] (state){
    state.workZoneItemLoading = true;
    state.workZoneItem = {};
    state.workZoneItemError = {};
  },
  [types.GET_WORK_ZONE_SUCCESS] (state, zone){
    state.workZoneItemLoading = false;
    state.workZoneItem = zone;
    state.workZoneItemError = {};
  },
  [types.GET_WORK_ZONE_FAILURE] (state, error){
    state.workZoneItemLoading = false;
    state.workZoneItem = {};
    state.workZoneItemError = error;
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
